import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useSnackbar } from "notistack";
import { brainTokens } from "../../design/brainTheme";
import { getCustomerEngagement, type CustomerEngagement } from "../../lib/brain-api";
import { ProjectActionsTab } from "./ProjectActionsTab";

const c = brainTokens.color;

export function CustomerEngagementTabMui({ customerId }: { customerId: string }) {
  const { enqueueSnackbar } = useSnackbar();
  const [eng, setEng] = useState<CustomerEngagement | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    getCustomerEngagement(customerId)
      .then((e) => {
        if (!cancelled) setEng(e);
      })
      .catch((err) => {
        if (!cancelled) {
          enqueueSnackbar(err instanceof Error ? err.message : String(err), { variant: "error" });
          setEng({ workStreams: [], anchorProjectId: null, actions: [] });
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [customerId, enqueueSnackbar]);

  if (loading) return <Box sx={{ fontSize: 13, color: c.muted2 }}>Loading engagement…</Box>;
  if (!eng) return null;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
      <Box sx={{ fontSize: 13, color: c.muted2 }}>
        Anchor{" "}
        <Box component="span" sx={{ fontFamily: brainTokens.font.mono, color: c.ink }}>
          {eng.anchorProjectId ?? "—"}
        </Box>
        {" · "}
        <Box component="span" sx={{ fontWeight: 700, color: c.ink }}>
          {eng.actions.length}
        </Box>{" "}
        actions ·{" "}
        <Box component="span" sx={{ fontWeight: 700, color: c.ink }}>
          {eng.workStreams.length}
        </Box>{" "}
        workstreams
      </Box>
      <ProjectActionsTab
        workStreams={eng.workStreams}
        initialActions={eng.actions}
        showProjectCol
      />
    </Box>
  );
}
